import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "glores-B-join-wrap glores-B-lan-kr" }
const _hoisted_5 = {
  name: "mem_reg_form",
  method: "post",
  enctype: "multipart/form-data"
}
const _hoisted_6 = { class: "glores-B-join-form glores-B-lan-kr" }
const _hoisted_7 = { class: "glores-B-value" }
const _hoisted_8 = { class: "reg_memberID" }
const _hoisted_9 = {
  key: 0,
  class: "glores-B-info"
}
const _hoisted_10 = {
  key: 1,
  class: "glores-B-error-msg"
}
const _hoisted_11 = { class: "glores-B-value" }
const _hoisted_12 = { class: "reg_password" }
const _hoisted_13 = {
  key: 0,
  class: "glores-B-info"
}
const _hoisted_14 = {
  key: 1,
  class: "glores-B-error-msg"
}
const _hoisted_15 = {
  key: 2,
  class: "glores-B-error-msg"
}
const _hoisted_16 = { class: "glores-B-value" }
const _hoisted_17 = { class: "reg_name" }
const _hoisted_18 = {
  key: 0,
  class: "glores-B-error-msg"
}
const _hoisted_19 = { class: "glores-B-value" }
const _hoisted_20 = { class: "reg_email" }
const _hoisted_21 = {
  key: 0,
  class: "glores-B-info"
}
const _hoisted_22 = {
  key: 1,
  class: "glores-B-error-msg"
}
const _hoisted_23 = { class: "glores-B-btn-wrap glores-B-m-half" }
const _hoisted_24 = { class: "btn-cell" }
const _hoisted_25 = { class: "btn-cell" }
const _hoisted_26 = {
  key: 0,
  class: "glores-B-error-msg glores-B-form-error"
}

import { ref, watch } from "vue";
import { useRouter } from "vue-router";

import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants";
import { useAuth } from "@/composables/useAuth";
import { Member } from "@/model/member";
import { useAlertDialog } from "@/composables/useAlert";
import Loading from "@/components/Loading.vue"; // Loading 컴포넌트 임포트
import * as common from "@/assets/common/common";

export default /*@__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const useAlert = useAlertDialog();
const loading = ref(false);
const isChecking = ref(false);
const isRegistering = ref(false);
const { signInWithCustomUser, existMember } = useAuth();
const router = useRouter();

const formData = ref({
  id: "", // 사용자 아이디 (username)
  password: "",
  passwordConfirm: "",
  name: "",
  email: "",
});

const errors = ref({
  id: "",
  password: "",
  passwordConfirm: "",
  name: "",
  email: "",
  general: "", // 폼 전체 또는 API 오류 메시지
});
const isIdCheckedAndAvailable = ref(false);
watch(
  () => formData.value.id,
  (newId, oldId) => {
    if (newId !== oldId) {
      isIdCheckedAndAvailable.value = false;
    }
  }
);
function goBack() {
  router.back();
}

const validateId = () => {
  errors.value.id = ""; // 현재 필드 오류 초기화
  let isValid = true;
  // 아이디 유효성 검사 (4~12자, 영문/숫자)
  const idRegex = /^[a-zA-Z0-9]{4,12}$/;
  if (!formData.value.id) {
    errors.value.id = "아이디를 입력해주세요.";
    isValid = false;
  } else if (!idRegex.test(formData.value.id)) {
    errors.value.id = "아이디는 4~12자의 영문 또는 숫자만 사용 가능합니다.";
    isValid = false;
  }
  return isValid;
};

const validatePassword = () => {
  errors.value.password = ""; // 현재 필드 오류 초기화
  let isValid = true;
  // 패스워드 유효성 검사 (8~16자, 영문, 숫자, 특수문자 조합)
  const passwordRegex =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,16}$/;
  if (!formData.value.password) {
    errors.value.password = "패스워드를 입력해주세요.";
    isValid = false;
  } else if (!passwordRegex.test(formData.value.password)) {
    errors.value.password =
      "패스워드는 8~16자의 영문, 숫자, 특수문자를 모두 포함해야 합니다.";
    isValid = false;
  }
  // 비밀번호가 변경되면 비밀번호 확인 필드도 다시 검증
  if (formData.value.passwordConfirm) {
    validatePasswordConfirm();
  }
  return isValid;
};

const validatePasswordConfirm = () => {
  errors.value.passwordConfirm = ""; // 현재 필드 오류 초기화
  let isValid = true;
  // 패스워드 확인
  if (!formData.value.passwordConfirm) {
    errors.value.passwordConfirm = "패스워드 확인을 입력해주세요.";
    isValid = false;
  } else if (formData.value.password !== formData.value.passwordConfirm) {
    errors.value.passwordConfirm = "패스워드가 일치하지 않습니다.";
    isValid = false;
  }
  return isValid;
};

const validateEmail = () => {
  errors.value.email = ""; // 현재 필드 오류 초기화
  let isValid = true;
  // 이메일 유효성 검사
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!formData.value.email) {
    errors.value.email = "이메일을 입력해주세요.";
    isValid = false;
  } else if (!emailRegex.test(formData.value.email)) {
    errors.value.email = "올바른 이메일 형식이 아닙니다.";
    isValid = false;
  }
  return isValid;
};

function validateFormBeforeSubmit(): boolean {
  // 모든 개별 유효성 검사를 실행하여 errors 객체를 최신 상태로 업데이트
  const isIdValid = validateId();
  const isPasswordValid = validatePassword();
  const isPasswordConfirmValid = validatePasswordConfirm();
  const isEmailValid = validateEmail();

  // 모든 필드가 유효한지 확인
  return isIdValid && isPasswordValid && isPasswordConfirmValid && isEmailValid;
}

async function join() {
  isRegistering.value = true;
  errors.value.general = "";
  try {
    const memberData: Member = {
      uid: formData.value.id,
      password: formData.value.password,
      name: formData.value.name == "" ? undefined : formData.value.name,
      email: formData.value.email,
      type: "custom",
    };
    let error = await signInWithCustomUser(memberData);
    if (error != null) {
      console.error("회원가입 실패:", error);
      errors.value.general = `회원가입 중 오류가 발생했습니다. (${
        error.message || "알 수 없는 오류"
      })`;
      isRegistering.value = false;
      await useAlert(errors.value.general);
    } else {
      router.push(
        `${USER_ROUTES.Join.Success.Path.replace(":id", formData.value.id)}`
      );
    }
  } catch (error: any) {
    console.error("회원가입 실패:", error);
    errors.value.general = `회원가입 중 오류가 발생했습니다. (${
      error.message || "알 수 없는 오류"
    })`;
    isRegistering.value = false;
    await useAlert(errors.value.general);
  } finally {
    isRegistering.value = false;
  }
}

async function processRegistration() {
  errors.value.general = ""; // 이전 일반 오류 메시지 초기화
  if (!validateFormBeforeSubmit()) {
    return;
  }
  if (!isIdCheckedAndAvailable.value) {
    errors.value.general = "아이디 중복 확인을 완료해주세요.";
    if (!errors.value.id) {
      errors.value.id = "아이디 중복 확인이 필요합니다.";
    }
    await useAlert(
      "아이디 중복 확인을 해주세요. 사용 가능한 아이디인지 확인 후 다시 시도해주세요."
    );

    return;
  }
  await join();
}

async function processExistMember() {
  errors.value.id = "";
  errors.value.general = "";
  isIdCheckedAndAvailable.value = false;

  if (!validateId()) {
    return;
  }
  isChecking.value = true;
  try {
    const memberData: Member = {
      uid: formData.value.id,
      type: "custom",
    };
    let result: any = await existMember(memberData);
    if (common.evalFunctionResult(result)) {
      if (result.data.data == false) {
        errors.value.id = ""; // 성공 시 이전 ID 오류 메시지 제거
        isIdCheckedAndAvailable.value = true;
        await useAlert("사용 가능한 아이디입니다.");
      } else {
        console.error("아이디 중복!");
        isChecking.value = false;
        errors.value.id = "이미 사용 중이거나 사용할 수 없는 아이디입니다.";
        isIdCheckedAndAvailable.value = false;
        await useAlert(errors.value.id);
      }
    } else {
      isIdCheckedAndAvailable.value = false;
      let error: any = common.getResultError(result);
      console.error("아이디 중복체크 실패:", error);
      isChecking.value = false;
      errors.value.general = `아이디 중복체크 중 오류가 발생했습니다. (${
        error.message || "알 수 없는 오류"
      })`;
      await useAlert(errors.value.general);
    }
  } catch (error: any) {
    isIdCheckedAndAvailable.value = false;

    console.error("아이디 중복체크 실패:", error);
    isChecking.value = false;
    errors.value.general = `아이디 중복체크 중 오류가 발생했습니다. (${
      error.message || "알 수 없는 오류"
    })`;
    await useAlert(errors.value.general);
  } finally {
    isChecking.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(Loading, null, null, 512), [
      [_vShow, loading.value]
    ]),
    _createVNode(Banner, {
      title: "",
      subtitle: "",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[17] || (_cache[17] = _createElementVNode("h1", { class: "sub_subject" }, [
          _createTextVNode("회원가입"),
          _createElementVNode("span")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "glores-B-join-step" }, [
            _createElementVNode("ol", null, [
              _createElementVNode("li", null, [
                _createElementVNode("span", null, "01 약관동의")
              ]),
              _createElementVNode("li", { class: "on" }, [
                _createElementVNode("span", null, "02 정보입력")
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", null, "03 가입완료")
              ])
            ])
          ], -1)),
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "glores-B-join-title" }, [
            _createElementVNode("h3", { class: "join-title" }, "정보입력")
          ], -1)),
          _createElementVNode("form", _hoisted_5, [
            _cache[14] || (_cache[14] = _createStaticVNode("<input type=\"hidden\" name=\"tmp_name\" value=\"tmp_val\" data-v-31752b26><input type=\"hidden\" name=\"this_site_mode\" value=\"1\" data-v-31752b26><input type=\"hidden\" name=\"this_domain\" data-v-31752b26><input type=\"hidden\" name=\"post_action\" data-v-31752b26><input type=\"hidden\" name=\"form_sess_id\" value=\"716vsn2hkvktapfcokmmb69lg7\" data-v-31752b26><input type=\"hidden\" name=\"marketing_agree_data\" value=\"\" data-v-31752b26><input type=\"hidden\" name=\"captcha_str_hash\" value=\"\" data-v-31752b26><h4 class=\"glores-B-join-form-title\" data-v-31752b26>필수 입력 항목</h4>", 8)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("dl", null, [
                _cache[7] || (_cache[7] = _createElementVNode("dt", null, [
                  _createElementVNode("label", { for: "id" }, [
                    _createTextVNode("아이디 "),
                    _createElementVNode("i", null, "*")
                  ])
                ], -1)),
                _createElementVNode("dd", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "id",
                        id: "id",
                        maxlength: "12",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.id) = $event)),
                        onInput: validateId
                      }, null, 544), [
                        [_vModelText, formData.value.id]
                      ]),
                      _createVNode(_component_n_button, {
                        type: "button",
                        loading: isChecking.value,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (processExistMember()))
                      }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode(" 아이디 중복체크 ")
                        ])),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ]),
                  (!errors.value.id)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, " 아이디는 4~12자의 영문, 숫자 조합으로 입력해주세요. "))
                    : _createCommentVNode("", true),
                  (errors.value.id)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(errors.value.id), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("dl", null, [
                _cache[10] || (_cache[10] = _createElementVNode("dt", null, [
                  _createElementVNode("label", { for: "pwd" }, [
                    _createTextVNode("패스워드 "),
                    _createElementVNode("i", null, "*")
                  ])
                ], -1)),
                _createElementVNode("dd", null, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[8] || (_cache[8] = _createElementVNode("input", {
                        type: "hidden",
                        name: "mem_link_yn",
                        value: ""
                      }, null, -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        name: "pwd",
                        id: "pwd",
                        size: "12",
                        maxlength: "16",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.password) = $event)),
                        onInput: validatePassword,
                        autocomplete: "new-password"
                      }, null, 544), [
                        [_vModelText, formData.value.password]
                      ]),
                      _cache[9] || (_cache[9] = _createElementVNode("label", { for: "pwd_re" }, "패스워드 확인", -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        name: "pwd_re",
                        id: "pwd_re",
                        size: "12",
                        maxlength: "16",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.passwordConfirm) = $event)),
                        onInput: validatePasswordConfirm
                      }, null, 544), [
                        [_vModelText, formData.value.passwordConfirm]
                      ])
                    ])
                  ]),
                  (!errors.value.password && !errors.value.passwordConfirm)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, " 패스워드는 영문+숫자+특수문자를 조합하여 8자 이상 입력해주세요. "))
                    : _createCommentVNode("", true),
                  (errors.value.password)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(errors.value.password), 1))
                    : _createCommentVNode("", true),
                  (errors.value.passwordConfirm)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(errors.value.passwordConfirm), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("dl", null, [
                _cache[11] || (_cache[11] = _createElementVNode("dt", null, [
                  _createElementVNode("label", { for: "name" }, "성명 ")
                ], -1)),
                _createElementVNode("dd", null, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "name",
                        id: "name",
                        size: "20",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.name) = $event)),
                        maxlength: "20"
                      }, null, 512), [
                        [_vModelText, formData.value.name]
                      ])
                    ])
                  ]),
                  (errors.value.name)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(errors.value.name), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("dl", null, [
                _cache[12] || (_cache[12] = _createElementVNode("dt", null, [
                  _createElementVNode("label", { for: "email" }, [
                    _createTextVNode("이메일 "),
                    _createElementVNode("i", null, "*")
                  ])
                ], -1)),
                _createElementVNode("dd", null, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "email",
                        id: "email",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.email) = $event)),
                        onInput: validateEmail
                      }, null, 544), [
                        [_vModelText, formData.value.email]
                      ])
                    ])
                  ]),
                  (!errors.value.email)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_21, " 이메일 주소를 입력하세요. "))
                    : _createCommentVNode("", true),
                  (errors.value.email)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(errors.value.email), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("a", {
                  onClick: _withModifiers(goBack, ["prevent"]),
                  class: "glores-B-btn-type1 glores-B-large glores-B-m-full-width"
                }, "이전")
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_n_button, {
                  type: "primary",
                  onClick: processRegistration,
                  class: "glores-B-btn-type1 glores-B-large glores-B-m-full-width glores-B-highlight",
                  loading: isRegistering.value,
                  style: {"--n-height":"unset !important"}
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode(" 회원가입 ")
                  ])),
                  _: 1
                }, 8, ["loading"])
              ]),
              (errors.value.general)
                ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(errors.value.general), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})